import { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { LANGUAGES } from '../i18n/languages';

function LanguageSelect() {
    const { language, setLanguage, t } = useLanguage();
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const current = LANGUAGES.find((item) => item.id === language) || LANGUAGES[0];

    useEffect(() => {
        if (!open) return undefined;

        const onPointerDown = (event) => {
            if (!rootRef.current?.contains(event.target)) setOpen(false);
        };
        const onKeyDown = (event) => {
            if (event.key === 'Escape') setOpen(false);
        };

        document.addEventListener('pointerdown', onPointerDown);
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('pointerdown', onPointerDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [open]);

    return (
        <div className={`lang-select${open ? ' is-open' : ''}`} ref={rootRef}>
            <button
                type="button"
                className="lang-select__button"
                aria-haspopup="listbox"
                aria-expanded={open}
                aria-label={t.language}
                onClick={() => setOpen((value) => !value)}
            >
                <span className="lang-select__flag" aria-hidden="true">
                    {current.flag}
                </span>
                <span className="lang-select__label">{current.label}</span>
                <span className="lang-select__chevron" aria-hidden="true" />
            </button>
            <ul className="lang-select__menu" role="listbox" aria-label={t.language} hidden={!open}>
                {LANGUAGES.map((item) => (
                    <li key={item.id} role="presentation">
                        <button
                            type="button"
                            className="lang-select__option"
                            role="option"
                            aria-selected={item.id === language}
                            onClick={(event) => {
                                event.stopPropagation();
                                setLanguage(item.id);
                                setOpen(false);
                            }}
                        >
                            <span className="lang-select__flag" aria-hidden="true">
                                {item.flag}
                            </span>
                            <span>{item.label}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default LanguageSelect;
